import axios from "axios";
import config from "../../../config";
import Blacklist, {
  BlacklistForm,
  CustomerGroupList,
  DeleteCustomers,
  NewCustomer,
} from "../interfaces/Blacklist";

const { ruleServerUrl } = config;

interface BlacklistDetails {
  data: CustomerGroupList[];
  totalSize: number;
}

const formData = (fileData: { [x: string]: string | Blob }) => {
  const formData = new FormData();
  for (const key in fileData) {
    formData.append(key, fileData[key]);
  }
  return formData;
};

export const getBlacklist = (businessName: string) => {
  return axios
    .get<{ data: Blacklist[] }>(
      `${ruleServerUrl}/users/customer-groups?business=${businessName}`
    )
    .then((res) => res.data.data);
};

export const createBlacklist = (data: BlacklistForm, businessName: string) => {
  return axios
    .post<{ data: Blacklist }>(
      `${ruleServerUrl}/users/customer-groups?business=${businessName}`,
      data
    )
    .then((res) => res.data.data);
};

export const addCustomer = (data: NewCustomer, businessName: string) => {
  return axios
    .post(
      `${ruleServerUrl}/users/assigned-customer-groups?business=${businessName}`,
      data
    )
    .then(({ data }) => data);
};

export const uploadCustomerBulk = (data: any, businessName: string) => {
  return axios
    .post(
      `${ruleServerUrl}/users/assigned-customer-groups/batch?business=${businessName}`,
      formData(data)
    )
    .then(({ data }) => data);
};

export const deleteBlacklist = (id: number, businessName: string) => {
  return axios
    .delete(
      `${ruleServerUrl}/users/customer-groups/${id}?business=${businessName}`
    )
    .then(({ data }) => data);
};

export const getBlacklistDetails = (
  id: string,
  businessName: string,
  page: number,
  size: number
) => {
  return axios
    .get<{data: BlacklistDetails}>(
      `${ruleServerUrl}/users/assigned-customer-groups?customerGroupId=${id}&business=${businessName}&page=${page}&size=${size}`
    )
    .then((res) => res.data.data);
};

export const searchCustomer = (
  id: string,
  mobile: number,
  businessName: string,
  page: number,
  size: number
) => {
  return axios
    .get<{data: BlacklistDetails}>(
      `${ruleServerUrl}/users/assigned-customer-groups?customerGroupId=${id}&mobileNumber=${mobile}&business=${businessName}&page=${page}&size=${size}`
    )
    .then((res) => res.data.data);
};

export const deleteCustomer = (data: DeleteCustomers, businessName: string) => {
  return axios
    .post(
      `${ruleServerUrl}/users/assigned-customer-groups/batch/delete?business=${businessName}`,
      data
    )
    .then(({ data }) => data);
};
